import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d9805d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "char-sheet" }
const _hoisted_2 = { class: "char-sheet__main-section" }
const _hoisted_3 = { class: "char-sheet__half-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SheetHeader = _resolveComponent("SheetHeader")!
  const _component_CharacterInfoSection = _resolveComponent("CharacterInfoSection")!
  const _component_MetaInfoSection = _resolveComponent("MetaInfoSection")!
  const _component_AspectSection = _resolveComponent("AspectSection")!
  const _component_DescriptionSection = _resolveComponent("DescriptionSection")!
  const _component_InventorySection = _resolveComponent("InventorySection")!
  const _component_SkillsSection = _resolveComponent("SkillsSection")!
  const _component_StuntsSection = _resolveComponent("StuntsSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SheetHeader),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CharacterInfoSection),
        _createVNode(_component_MetaInfoSection)
      ]),
      _createVNode(_component_AspectSection),
      _createVNode(_component_DescriptionSection),
      _createVNode(_component_InventorySection),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SkillsSection),
        _createVNode(_component_StuntsSection)
      ])
    ])
  ], 64))
}